<template>
  <div id="dashboard-container">
    <div>
      <dialog id="modal-addPerson-container">
        <svg @click="closeModal('modal-addPerson-container')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <select v-model="addPeopleSelect">
          <option value="child">Student/Patient</option>
          <option value="specialist">Specialist</option>
          <option value="caseManager">Case Manager</option>
        </select>
        <div v-if="addPeopleSelect == 'child'">
          <div class="inputGrid">
            <div>First Name*</div>
            <div>Last Name*</div>
            <input type="text" v-model="inputObjectChild.firstName" />
            <input type="text" v-model="inputObjectChild.lastName" />
            <div class="span2">Email*</div>
            <div class="span2">
              <input type="email" v-model="inputObjectChild.email" />
            </div>
            <div class="span2">Phone Number*</div>
            <div class="span2">
              <input type="tel" v-model="inputObjectChild.phoneNumber" />
            </div>
          </div>
          <button v-if="!loadingAddChild" @click="addChild">
            + Child
          </button>
          <button v-else>
            <b-spinner small></b-spinner>
            + Child
          </button>
        </div>
        <div v-if="addPeopleSelect == 'specialist'">
          <div class="inputGrid">
            <div>First Name*</div>
            <div>Last Name*</div>
            <input type="text" v-model="inputObjectSpecialist.firstName" />
            <input type="text" v-model="inputObjectSpecialist.lastName" />
            <div class="span2">Email*</div>
            <div class="span2">
              <input type="email" v-model="inputObjectSpecialist.email" />
            </div>
            <div class="span2">Phone Number*</div>
            <div class="span2">
              <input type="tel" v-model="inputObjectSpecialist.phoneNumber" />
            </div>
          </div>
          <button v-if="!loadingAddSpecialist" @click="addSpecialist">
            + Specialist
          </button>
          <button v-else>
            <b-spinner small></b-spinner>
          + Specialist
          </button>
        </div>
        <div v-if="addPeopleSelect == 'caseManager'">
          <div class="inputGrid">
          <div>First Name*</div>
            <div>Last Name*</div>
            <input type="text" v-model="inputObjectCaseManager.firstName" />
            <input type="text" v-model="inputObjectCaseManager.lastName" />
            <div class="span2">Email*</div>
            <div class="span2">
              <input type="email" v-model="inputObjectCaseManager.email" />
            </div>
            <div class="span2">Phone Number*</div>
            <div class="span2">
              <input type="tel" v-model="inputObjectCaseManager.phoneNumber" />
            </div>
          </div>
          <button v-if="!loadingAddCaseManager" @click="addCaseManager">
            + Case Manager
          </button>
          <button v-else>
            <b-spinner small></b-spinner>
            + Case Manager
          </button>
        </div>
      </dialog>
      <dialog id="modal-managePeopleChildInfo-container">
        <svg @click="closeModal('modal-managePeopleChildInfo-container'); resetManagePeopleRowData()" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <svg @click="deleteChild(managePeopleRowData.user.child_id); closeModal('modal-managePeopleChildInfo-container')" class="trash-delete" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/></svg>
        <div v-if="managePeopleRowData">
          <div class="profile-container">
            <span class="profile-pic"></span>
            <h3>{{ `${managePeopleRowData.user.first_name} ${managePeopleRowData.user.last_name}` }}</h3>
            <small>Joined {{ formatTimestamp(managePeopleRowData.user.created_at) }}</small>
          </div>
          <hr />
          <h5>Basic Info</h5>
          <div>Child ID: {{ managePeopleRowData.user.child_id }}</div>
          <div>Email: {{ managePeopleRowData.user.email }}</div>
          <div>Phone Number: {{ managePeopleRowData.user.phone_number }}</div>
          <div>Date Added: {{ formatTimestamp(managePeopleRowData.user.created_at) }}</div>
          <hr />
          <div>
            <h5>Guardians</h5>
            <div v-for="(guardian,index) of managePeopleRowData.guardians" :key="`guardian-${index}`">
              {{ guardian }}
            </div>
          </div>
          <hr />
          <div>
            <h5>Assigned Specialist</h5>
            <div>
              <div>
                <select v-model="inputAssignSpecialist">
                  <option value="none">Select Specialist To Assign</option>
                  <option v-for="(specialist, index) of peopleDataObject.specialists" :value="specialist.specialist_id"  :key="`specialist-option${index}`">
                    {{ `${specialist.first_name} ${specialist.last_name}` }}
                  </option>
                </select>
                <button @click="assignSpecialist(managePeopleRowData.user.child_id,inputAssignSpecialist)">Assign New Specialist</button>
              </div>
              <div v-for="(specialist,index) of managePeopleRowData.specialists" :key="`specialist-${index}`">
                {{ `${specialist.first_name} ${specialist.last_name}` }}
              </div>
            </div>
          </div>
          <hr />
          <div>
            <h5>Assigned Case Managers</h5>
            <div>
              <select v-model="inputAssignCaseManager">
                <option value="none">Select Case Manager To Assign</option>
                <option v-for="(manager, index) of peopleDataObject.case_managers" :value="manager.case_manager_id" :key="`specialist-option${index}`">
                  {{ `${manager.first_name} ${manager.last_name}` }}
                </option>
              </select>
              <button @click="assignCaseManager(managePeopleRowData.user.child_id, inputAssignCaseManager)">Assign New Case Manager</button>
            </div>
            <div>
              <div v-for="(manager,index) of managePeopleRowData.case_managers" :key="`manager-${index}`">
                {{ `${manager.first_name} ${manager.last_name}` }}
              </div>
            </div>
          </div>
        </div>
      </dialog>
      <dialog id="modal-managePeopleCaseManagerInfo-container">
        <svg @click="closeModal('modal-managePeopleCaseManagerInfo-container'); resetManagePeopleRowData()" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <svg @click="deleteSpecialist(managePeopleRowData.user.case_manager_id); closeModal('modal-managePeopleCaseManagerInfo-container')" class="trash-delete" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/></svg>
        <div v-if="managePeopleRowData">
          <div class="profile-container">
            <span class="profile-pic"></span>
            <h3>{{ `${managePeopleRowData.user.first_name} ${managePeopleRowData.user.last_name}` }}</h3>
            <small>Joined {{ formatTimestamp(managePeopleRowData.user.created_at) }}</small>
          </div>
          <hr />
          <h5>Basic Info</h5>
          <div>Manager ID: {{ managePeopleRowData.user.case_manager_id }}</div>
          <div>Email: {{ managePeopleRowData.user.email }}</div>
          <div>Phone Number: {{ managePeopleRowData.user.phone_number }}</div>
          <div>Date Added: {{ formatTimestamp(managePeopleRowData.user.created_at) }}</div>
        </div>
      </dialog>
      <dialog id="modal-managePeopleSpecialistInfo-container">
        <svg @click="closeModal('modal-managePeopleSpecialistInfo-container'); resetManagePeopleRowData()" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <svg @click="deleteSpecialist(managePeopleRowData.user.specialist_id); closeModal('modal-managePeopleSpecialistInfo-container')" class="trash-delete" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/></svg>
        <div v-if="managePeopleRowData">
          <div class="profile-container">
            <span class="profile-pic"></span>
            <h3>{{ `${managePeopleRowData.user.first_name} ${managePeopleRowData.user.last_name}` }}</h3>
            <small>Joined {{ formatTimestamp(managePeopleRowData.user.created_at) }}</small>
          </div>
          <hr />
          <h5>Basic Info</h5>
          <div>Specialist ID: {{ managePeopleRowData.user.specialist_id }}</div>
          <div>Email: {{ managePeopleRowData.user.email }}</div>
          <div>Phone Number: {{ managePeopleRowData.user.phone_number }}</div>
          <div>Date Added: {{ formatTimestamp(managePeopleRowData.user.created_at) }}</div>
        </div>
      </dialog>
    </div>
    <div id="sidebar-container">
      <h2>Dashboard</h2>
      <div id="sidebar-tabs-container">
        <div @click="changeTab('home')" :class="['sidebar-tab', currentTab == 'home' ? 'active' : null]">Home</div>
        <!-- <div @click="changeTab('myActivities')" :class="['sidebar-tab', currentTab == 'myActivities' ? 'active' : null]">My Activites</div> -->
        <div class="sidebar-divider">
          <hr />
        </div>
        <div @click="changeTab('managePeople')" :class="['sidebar-tab', currentTab == 'managePeople' ? 'active' : null]">Manage People</div>
      </div>
    </div>
    <div id="main-container">
      <div v-if="currentTab == 'home-container'">
        home
      </div>
      <div v-else-if="currentTab == 'myActivities'" id="myActivities-container">
        <h3>Owned Apps</h3>
        <div class="owned-app-container">
          <div>
            <h4>App Name 1</h4>
            <div class="categorization-container">
              <div>Area</div>
              <div>
                Area1
              </div>
              <div>Type</div>
              <ul>
                <li>Type1</li>
                <li>Type2</li>
              </ul>
              <div>Category</div>
              <ul>
                <li>Category1</li>
                <li>Category2</li>
              </ul>
              <div>SubCategory</div>
              <ul>
                <li>SubCategory1</li>
                <li>SubCategory2</li>
              </ul>
            </div>
          </div>
          <div>
            <div class="owned-app-buttons-container">
              <button>View All Testers</button>
              <button>Add Child</button>
            </div>
            <div class="info-box">
              <div class="stats-box">
                Stats
                <div>average percentage, total hours</div>
              </div>
              <div class="usage-box">
                Usage
                <div>Units Total, units used, units left</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="currentTab == 'managePeople'" id="managePeople-container">
        <div id="manage-container">
          <h3>Manage People</h3>
          <div id="table-functions">
            <div id="searchApp-container">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
              <input placeholder="Search" style="display: inline-block;" />
            </div>
            <span>
              <button>Filters</button>
              <button @click="openModal('modal-addPerson-container')">+ Add Person</button>
            </span>
          </div>
          <div id="manage-people-container">
            <table>
              <thead>
                <tr>  
                  <th>People</th>
                  <th>Type</th>
                  <th>Date Added</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(person, index) in peopleDataArray" @click="managePeopleRowInfoOpen(person)" :key="index">
                  <td>{{ `${person.first_name} ${person.last_name}` }}</td>
                  <td>
                    <span v-if="person.hasOwnProperty('child_id')" class="child-cylinder">Child</span>
                    <span v-else-if="person.hasOwnProperty('specialist_id')" class="specialist-cylinder">Specialist</span>
                    <span v-else-if="person.hasOwnProperty('case_manager_id')" class="caseManager-cylinder">Case Manager</span>
                  </td>
                  <td>{{ formatTimestamp(person.created_at) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import instance from '../axios.js';

  export default {
    data() {
      return {
        currentTab: 'home',
        addPeopleSelect: 'child',
        peopleDataArray: null,
        peopleDataObject: null,
        managePeopleRowData: null,
        inputAssignSpecialist: 'none',
        inputAssignCaseManager: 'none',
        inputObjectChild: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
        },
        inputObjectSpecialist: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
        },
        inputObjectCaseManager: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
        },
        inputObjectTeacher: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
        },
        loadingAddChild: false,
        loadingAddSpecialist: false,
        loadingAddCaseManager: false,
        loadingAddTeacher: false,
      }
    },
    async created() {
      try {
        let peopleResponse = await instance.get(`/api/user/people/${this.$store.getters.getCurrentUser}`);
        this.peopleDataArray = [].concat(peopleResponse.data.case_managers, peopleResponse.data.children, peopleResponse.data.guardians, peopleResponse.data.specialists);
        this.peopleDataObject = peopleResponse.data;
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      changeTab(tab) {
        this.currentTab = tab;
      },
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      async addChild() {
        try {
          this.loadingAddChild = true;

          for (const key in this.inputObjectChild) {
            if (this.inputObjectChild[key] === "") {
              alert('empty field');
              this.loadingAddChild = false;
              break;
            }
          }

          await instance.post(`/api/child`, {
            user_id: this.$store.getters.getCurrentUser,
            first_name: this.inputObjectChild.firstName,
            last_name: this.inputObjectChild.lastName,
            email: this.inputObjectChild.email,
            phone_number: this.inputObjectChild.phoneNumber,
          })

          this.clearInputObject(this.inputObjectChild);
          this.loadingAddChild = false;

          let peopleResponse = await instance.get(`/api/user/people/${this.$store.getters.getCurrentUser}`);
          this.peopleDataArray = [].concat(peopleResponse.data.case_managers, peopleResponse.data.children, peopleResponse.data.guardians, peopleResponse.data.specialists);
          this.peopleDataObject = peopleResponse.data;
        } catch (e) {
          this.loadingAddChild = false;
          console.error(e);
        }
      },
      async addSpecialist() {
        try {
          this.loadingAddSpecialist = true;

          for (const key in this.inputObjectSpecialist) {
            if (this.inputObjectSpecialist[key] === "") {
              alert('empty field');
              this.loadingAddSpecialist = false;
              break;
            }
          }

          await instance.post(`/api/specialist`, {
            user_id: this.$store.getters.getCurrentUser,
            first_name: this.inputObjectSpecialist.firstName,
            last_name: this.inputObjectSpecialist.lastName,
            email: this.inputObjectSpecialist.email,
            phone_number: this.inputObjectSpecialist.phoneNumber,
          })

          this.clearInputObject(this.inputObjectSpecialist);
          this.loadingAddSpecialist = false;

          let peopleResponse = await instance.get(`/api/user/people/${this.$store.getters.getCurrentUser}`);
          this.peopleDataArray = [].concat(peopleResponse.data.case_managers, peopleResponse.data.children, peopleResponse.data.guardians, peopleResponse.data.specialists);
          this.peopleDataObject = peopleResponse.data;
        } catch (e) {
          this.loadingAddSpecialist = false;
          console.error(e);
        }
      },
      async addCaseManager() {
        try {
          this.loadingAddCaseManager = true;

          for (const key in this.inputObjectCaseManager) {
            if (this.inputObjectCaseManager[key] === "") {
              alert('empty field');
              this.loadingAddCaseManager = false;
              break;
            }
          }

          await instance.post(`/api/cm`, {
            user_id: this.$store.getters.getCurrentUser,
            first_name: this.inputObjectCaseManager.firstName,
            last_name: this.inputObjectCaseManager.lastName,
            email: this.inputObjectCaseManager.email,
            phone_number: this.inputObjectCaseManager.phoneNumber,
          })

          this.clearInputObject(this.inputObjectCaseManager);
          this.loadingAddCaseManager = false;

          let peopleResponse = await instance.get(`/api/user/people/${this.$store.getters.getCurrentUser}`);
          this.peopleDataArray = [].concat(peopleResponse.data.case_managers, peopleResponse.data.children, peopleResponse.data.guardians, peopleResponse.data.specialists);
          this.peopleDataObject = peopleResponse.data;
        } catch (e) {
          console.error(e);
          this.loadingAddCaseManager = false;
        }
      },
      clearInputObject(obj) {
        Object.keys(obj).forEach(key => {
          obj[key] = "";
        });
      },
      formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      },
      async managePeopleRowInfoOpen(person) {
        try {
          if (Object.prototype.hasOwnProperty.call(person, 'child_id')) {
            let connectionResponse = await instance.get(`/api/child/people/${person.child_id}`);
            this.managePeopleRowData = {
              user: person,
              ...connectionResponse.data
            };
            this.openModal('modal-managePeopleChildInfo-container');
          } else if (Object.prototype.hasOwnProperty.call(person, 'specialist_id')) {
            this.managePeopleRowData = {
              user: person
            };
            this.openModal('modal-managePeopleSpecialistInfo-container');
          } else if (Object.prototype.hasOwnProperty.call(person, 'case_manager_id')) {
            this.managePeopleRowData = {
              user: person
            };
            this.openModal('modal-managePeopleCaseManagerInfo-container');
          }
          console.log(this.managePeopleRowData)
        } catch (e) {
          console.error(e);
        }
      },
      resetManagePeopleRowData() {
        this.managePeopleRowData = null;
      },
      async assignSpecialist(child_id, specialist_id) {
        try {
          if (this.inputAssignSpecialist == 'none') {
            alert('Please Input Specialist');
            return;
          }
          await instance.post(`/api/child-specialist-junction`, {
            child_id,
            specialist_id
          });
        } catch (e) {
          console.error(e);
        }
      }, 
      async assignCaseManager(child_id, case_manager_id) {
        try {
          if (this.inputAssignCaseManager == 'none') {
            alert('Please Input Case Manager');
            return;
          }
          await instance.post(`/api/child-case-manager-junction`, {
            child_id,
            case_manager_id
          });
        } catch (e) {
          console.error(e);
        }
      }, 
      async deleteChild(child_id) {
        try {
          await instance.delete(`/api/child/${child_id}`);
          let peopleResponse = await instance.get(`/api/user/people/${this.$store.getters.getCurrentUser}`);
          this.peopleDataArray = [].concat(peopleResponse.data.case_managers, peopleResponse.data.children, peopleResponse.data.guardians, peopleResponse.data.specialists);
          this.peopleDataObject = peopleResponse.data;
        } catch (e) {
          console.error(e);
        } 
      },
      async deleteSpecialist(specialist_id) {
        try {
          await instance.delete(`/api/specialist/${specialist_id}`);
          let peopleResponse = await instance.get(`/api/user/people/${this.$store.getters.getCurrentUser}`);
          this.peopleDataArray = [].concat(peopleResponse.data.case_managers, peopleResponse.data.children, peopleResponse.data.guardians, peopleResponse.data.specialists);
          this.peopleDataObject = peopleResponse.data;
        } catch (e) {
          console.error(e);
        } 
      },
      async deleteCaseManager(case_manager_id) {
        try {
          await instance.delete(`/api/cm/${case_manager_id}`);
          let peopleResponse = await instance.get(`/api/user/people/${this.$store.getters.getCurrentUser}`);
          this.peopleDataArray = [].concat(peopleResponse.data.case_managers, peopleResponse.data.children, peopleResponse.data.guardians, peopleResponse.data.specialists);
          this.peopleDataObject = peopleResponse.data;
        } catch (e) {
          console.error(e);
        } 
      },
    },
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #dashboard-container {
    $sidebar-width: 300px;
    position: relative;

    h2 {
      text-align: center;
      margin: 1rem 0;
    }

    #sidebar-container {
      width: $sidebar-width;
      position: fixed;
      height: calc(100dvh - #{globalSharedVariables.$navbar-height});
      left: 0;
      box-shadow: 0 0 20px 0px rgb(230, 230, 230);

      #sidebar-tabs-container {
        overflow-y: auto;

        .sidebar-tab {
          padding: .5rem;
          cursor: pointer;

          &:hover {
            border-right: 3px solid globalSharedVariables.$brand-400;
          }

          &.active {
            border-right: 3px solid globalSharedVariables.$brand-400;
            color: globalSharedVariables.$brand-400;
          }
        }
      }

      .sidebar-divider {
        display: flex;
        justify-content: center;

        hr {
          border: solid black 1px;
          width: 90%;
        }
      }
    }

    #main-container {
      margin-left: $sidebar-width;
      background-color: #F8FBFF;
      min-height: calc(100dvh - #{globalSharedVariables.$navbar-height} - #{globalSharedVariables.$footerbar-height});
      padding: 0 1rem;

      > div {
        padding: 1rem;
      }

      #myActivities-container {
        .owned-app-container {
          background-color: globalSharedVariables.$accent-200;
          border-radius: 1rem;
          padding: 1rem;
          display: grid;
          grid-template-columns: 1fr 4fr;
          column-gap: 1rem;
          box-shadow: 0 0 20px 0px rgb(230, 230, 230);

          > div:nth-child(1) {
            padding: .5rem;
            background-color: globalSharedVariables.$accent-100;
            border-radius: 1rem;

            .categorization-container {
              overflow: auto;
              height: 150px;
              display: grid;
              grid-template-columns: auto auto;
            }
          }

          > div:nth-child(2) {
            display: flex;
            flex-direction: column;

            .owned-app-buttons-container {
              display: flex;
              justify-content: space-between;
            }

            .info-box {
              display: grid;
              grid-template-columns: 1fr 1fr;
              column-gap: 1rem;

              .stats-box, .usage-box {
                background-color: globalSharedVariables.$accent-100;
                padding: 1rem;
                border-radius: 1rem;
              }
            }

            button {
              font-size: .7rem;
            }
          }
        }
      }

      #managePeople-container {
        #manage-container {
          background-color: #FCFEFF;
          border-radius: 1rem;
          height: calc(100dvh - #{globalSharedVariables.$navbar-height} - #{globalSharedVariables.$footerbar-height} - 32px);
          box-shadow: 0 0 20px 0px rgb(230, 230, 230);
          padding: 1rem;

          #table-functions {
            display: flex;
            justify-content: space-between;
            margin-bottom: .5rem;

            #searchApp-container {
              box-shadow: 0 0 5px 0 lightgrey;
              border-radius: 50rem;
              border: solid 1px globalSharedVariables.$brand-400;
              background-color: white;
              padding: 0 10px;
              height: min-content;

              svg {
                height: 1rem;
              }

              input {
                font-size: 1rem;
                border: none;
                box-shadow: none;
                margin: 0 5px;

                &:focus {
                  border: 0;
                  outline: 0;
                }

                &::placeholder {
                  text-align: center;
                }
              }
            }

            button {
              padding: 0 10px;
              margin: 0 5px;
            }
          }

          #manage-people-container {
            table {
              width: 100%;
              $header-border-radius: 7px;
              border-collapse: collapse;

              thead {
                color: rgb(83, 83, 83);
                font-size: 1rem;

                th {
                  background-color: #F2F3F6;
                  font-weight: 400;
                  padding: 5px;
                }

                th:nth-child(1) {
                  width: 50%;
                }

                th:first-child {
                  border-top-left-radius: $header-border-radius;
                  border-bottom-left-radius: $header-border-radius;

                }
                th:last-child {
                  border-top-right-radius: $header-border-radius;
                  border-bottom-right-radius: $header-border-radius;
                }
              }

              tbody {
                font-size: .9rem;

                tr {
                  &:hover {
                    background-color: globalSharedVariables.$brand-100;
                    cursor: pointer;
                  }

                  td {
                    padding: .2rem;

                    .child-cylinder, .specialist-cylinder, .caseManager-cylinder {
                      border-radius: 50rem;
                      padding: 0 5px;
                    }

                    .child-cylinder {
                      color: #005F37;
                      border: solid 1px #B5EECB;
                      background-color: #F1FDF3;
                    }

                    .specialist-cylinder {
                      color: #004FC8;
                      border: solid 1px #B6DDFF;
                      background-color: #F2F7FB;
                    }

                    .caseManager-cylinder {
                      color: #3B00CF;
                      border: solid 1px #DBD7FA;
                      background-color: #F6F4FF;
                    }
                  }

                  td:nth-child(1) {
                    padding-left: 5px;
                  }

                  td:last-child {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }

                  svg {
                    height: 20px;
                    fill: #A4A4A4;
                    
                    &:hover {
                      cursor: pointer;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    #modal-addPerson-container {
      .inputGrid {
        display: grid;
        grid-template-columns: auto auto;
        column-gap: 1rem;
        margin-top: 1rem;

        .span2 {
          grid-column: span 2;
          
          input {
            width: 100%;
          }
        }
      }

      button {
        margin-top: 1rem;
      }
    }

    #modal-managePeopleChildInfo-container, #modal-managePeopleCaseManagerInfo-container, #modal-managePeopleSpecialistInfo-container {
      border-radius: 10px;

      &::after {
        content: '';
        position: absolute;
        background-color: globalSharedVariables.$brand-100;
        width: 100%;
        height: 100px;
        left: 0;
        top: 0;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        z-index: -1;
      }

      .profile-container {
        display: flex;
        flex-direction: column;
        align-items: center;

        .profile-pic {
          height: 100px;
          width: 100px;
          background-color: globalSharedVariables.$brand-400;
          border-radius: 50rem;
        }
      }

      hr {
        border: solid black 1px;
      }

      button {
        margin-left: 5px;
        padding: 2px 10px;
      }

      .trash-delete {
        position: absolute;
        left: 1rem;
        top: 1rem;
        cursor: pointer;
        height: 25px;

        &:hover {
          fill: red;
        }
      }
    }
  }
</style>